const getPermissionsIds = (permissions, backendPermissions) => {
  const permissionsIds = []

  permissions?.map(permission => {
    const permissionId = backendPermissions?.find(backendPermission => backendPermission?.codename === permission)
    if (permissionId) {
      permissionsIds.push(permissionId?.id)
    }
  })
  return permissionsIds
}

export const getGroupPayload = ({ id, name, color, permissions, backendPermissions = [] }) => {
  const payload = {
    id,
    name,
    color,
    permissions: getPermissionsIds(permissions, backendPermissions),
  }

  if (id === 'new') {
    delete payload.id
  }

  return payload
}

export const checkAndAddRequiredPermissions = permissions => {
  const newPermissionsSet = new Set(permissions)

  permissions.forEach(permission => {
    if (permission.startsWith('edit_')) {
      const viewPermission = permission.replace('edit_', 'view_')
      if (!newPermissionsSet.has(viewPermission)) {
        newPermissionsSet.add(viewPermission)
      }
    }
  })

  return [...newPermissionsSet]
}
